export enum DermloopRatingEnum {
  Good = 'good',
  Bad = 'bad',
}
